import React from 'react';
import { Link } from 'react-router-dom';
import logout from '../Components/Image/logout.png'
import Sidebar from '../Components/Sidebar';
import { Button, Table } from 'react-bootstrap';
import { connect } from 'react-redux'
import { getPODetails, GetPOAndPOLineItemSummary, getSearchedPO, getProjectAllocationByUserId } from '../store/actions/poDetailsActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import formatDate from '../Classes/FormatDate'
import AuthHandlerInstance from '../Classes/AuthHandler'
import SearchBar from '../Components/SearchBar';
import Pagination from 'react-bootstrap/Pagination'
import authInstance from '../Classes/AuthHandler';
import Manufacturing_Clearence from '../Components/Manufacturing_Clearence';
import Loading from '../Components/Loader';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import { updatePOLineItemClearenceStatus } from '../store/actions/expediting.Actions'
import toast from 'react-hot-toast';
import PaginationComponent from '../Components/PaginationComponent';
import Select, { components } from "react-select";
import { GetFilterList } from '../store/actions/masterActions'

class ManufacturingClearence extends React.Component {
    constructor(props) {
        super(props);
        this.dateformate = this.dateformate.bind(this);
        this.state = {
            userId: AuthHandlerInstance.getUserID(),
            employee: AuthHandlerInstance.getUserPayLoad(),
            roles: AuthHandlerInstance.getRoles(),
            selectedItem: {},
            searchTerm: "",
            tableData: [],
            posPerpage: 10,
            Manufacturing_Clearence: false,
            varId: "",
            select: false,
            currentPage: 1,
            posPerpage: 10,
            totalPos: 0,
            selected: [],
            checked: [],
            checkedArray: [],
            sortByPODocDate: [],
            sortBy: 'all',
            sortByVendor: [],
            sortByPo: [],
            sortByWBS: [],
            sortByPlantCode: [],
            sortByEmployees: [],
            poDocStartDate: '',
            poDocEndDate: '',
            latestDcStartDate: '',
            latestDcEndDate: '',
            statDeliveryStartDate: '',
            statDeliveryEndDate: '',
            drgApprovalStartDate: '',
            drgApprovalEndDate: '',
            docStatus: {
                0: { title: "", badge: "", status: "" },
                1: { title: "HOLD", badge: "badge-warning", status: "" },
                2: { title: "Released", badge: "badge-primary", status: "" },
                3: { title: "Clearence Given", badge: "badge-success", status: "" },
            },
            loading: true,
            isShowFilter: false,
            finalvendorlist: [],
            finalpos: [],
            finalwbsno: [],
            finalplantcode: [],
            VendorName: [],
            PlantCode: [],
            POSAPId: [],
            WBSCode: [],
            searchForOptions: [
                { label: 'Currency', value: 'Currency' },
                { label: 'Location', value: 'Location' },
                { label: 'Material', value: 'Material' },
                { label: 'Plant Code', value: 'Plant Code' },
                { label: 'PO Number', value: 'PO Number' },
                { label: 'Vendor', value: 'Vendor' },
                { label: 'Project No.', value: 'WBS' },
            ],
            searchForItem:[]
        }
        this.handleDataLoading = this.handleDataLoading.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.Manufacturing_Clearence = this.Manufacturing_Clearence.bind(this);
    }



    componentDidMount() {

        this.handleDataLoading()

    }

    handleDataLoading = async () => {
        let roles = AuthHandlerInstance.getRoles()
        let userId = AuthHandlerInstance.getUserID()
        if (roles[12]) {
            let sortByWBS = []
            let WBSCode = []
            await this.props.getProjectAllocationByUserId({ UserId: userId })
            let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
            if (ProjectCodes.length > 0) {
                ProjectCodes.map((elem) => {
                    sortByWBS.push(elem.ProjectCode)
                    WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
                })
            }
            await this.setState({ sortByWBS, WBSCode })
        }
        await this.filterData(this.state.currentPage)
        await this.getFilterList()
    }

    // ? handle search input
    handleISearch = (e) => {

        let searchTerm = e.target.value

        this.setState({
            searchTerm
        })

        console.log(this.state.searchTerm)

    }



    // ? handle searching
    handleSearching = async () => {
        await this.filterData()
    }


    dateformate(dateVal) {
        let d = new Date(dateVal);
        return d.toDateString();
    }

    handleClick = async (event) => {
        let currentPage = Number(event.target.id)
        if (!event.target.id) {
            currentPage = event.target.offsetParent.id
        }
        await this.filterData(currentPage)
    }

    modalopen() {
        console.log("hi")
    }

    rowClick = async (index) => {
        console.log(index, "idddd")
        let id = this.state.tableData[index].PurchaseOrderLineId
        await this.setState({ varId: id })
        await this.Manufacturing_Clearence()
    }

    Manufacturing_Clearence() {
        this.setState({ Manufacturing_Clearence: !this.state.Manufacturing_Clearence });
        this.setState({ RetentionDocumentsModal: false });
        if (this.state.Manufacturing_Clearence == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }

    toggleManufacturing_Clearence = async (e) => {
        await this.setState({ Manufacturing_Clearence: !this.state.Manufacturing_Clearence });
        if (this.state.Manufacturing_Clearence == true) {
            this.setState(
                { opacity: "" }
            )
        }
        else {
            this.setState(
                { opacity: "0.2", varId: "" }
            )
        }
    }

    handleChange = () => {
        try {
            let selected = [];
            let select = !this.state.select;
            console.log(select, '??????////')
            this.state.tableData.map((item, index) => {
                if (!item.DeletionIndicator) {
                    if (select == true) {
                        selected.push(item.PurchaseOrderLineId)
                    }
                }
            });
            this.setState({ selected: selected, select: select });
        } catch (e) {
            console.log(e);
        }
    };

    handleSingleCheckboxChange = index => {
        var checkedArray = this.state.checkedArray
        let selected = [...this.state.selected];
        let select = ''
        if (!selected.includes(index)) {
            selected.push(index)
        } else {
            selected = selected.filter((e) => e !== index)
            select = false
        }
        if (select == false) {
            this.setState({ select })
        }
        this.setState({ selected });


    };

    updateStatus = async (Status) => {
        await this.state.selected.map(async (item, index) => {
            // console.log(this.state.tableData[index].PurchaseOrderId,"POID", item,"POLINEITEMID")
            await this.props.updatePOLineItemClearenceStatus(
                this.state.tableData.find((e) => e.PurchaseOrderLineId == item).PurchaseOrderId,
                item,
                Status,
                this.state.employee.fullName
            )
            await this.handleDataLoading()
        })
        if (Status == 1) {
            toast.success('Selected Line Items Are Put On Hold', {
                duration: 1000
            });
        }
        else if (Status == 2) {
            toast.success('Selected Line Items Are Released from Hold', {
                duration: 1000
            });
        } else {
            toast.success('Selected Line Items Are Released For Manufacturnig', {
                duration: 1000
            });
        }
    }

    filterData = async (currentPage = 1) => {
        await this.setState({ loading: true })
        let tableData = []
        let totalPos = 0
        let searchData = {
            currentPage: currentPage,
            posPerpage: this.state.posPerpage,
            searchTerm: this.state.searchTerm,
            poStatus: '1,2,3,5,6,7',
            userId: this.state.userId,
            sortByEmployees: this.state.sortByEmployees,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            sortByPo: this.state.sortByPo,
            sortByVendor: this.state.sortByVendor,
            sortBy: this.state.sortBy,
            poDocStartDate: this.state.poDocStartDate,
            poDocEndDate: this.state.poDocEndDate,
            latestDcStartDate: this.state.latestDcStartDate,
            latestDcEndDate: this.state.latestDcEndDate,
            drgApprovalStartDate: this.state.drgApprovalStartDate,
            drgApprovalEndDate: this.state.drgApprovalEndDate,
            statDeliveryStartDate: this.state.statDeliveryStartDate,
            statDeliveryEndDate: this.state.statDeliveryEndDate,
            searchFor: this.state.searchFor
        }

        await this.props.GetPOAndPOLineItemSummary(searchData)
        if (this.props.poDetails && this.props.poDetails.poAndPoLineItemSearch && this.props.poDetails.poAndPoLineItemSearch.pos) {
            tableData = this.props.poDetails.poAndPoLineItemSearch.pos
            totalPos = this.props.poDetails.poAndPoLineItemSearch.pageinfo.totalcount
        }
        await this.setState({
            tableData, totalPos, loading: false, currentPage: currentPage, select: false,
            selected: [],
            checked: [],
            checkedArray: [],
        })
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    clearFilter = async () => {
        await this.setState({
            isShowFilter: false,
            searchTerm: '',
            searchFor: '',
            sortByPlantCode: [],
            sortByPo: [],
            sortByVendor: [],
            sortByWBS: [],
            finalvendorlist: [],
            finalpos: [],
            finalwbsno: [],
            finalplantcode: [],
            VendorName: [],
            PlantCode: [],
            POSAPId: [],
            WBSCode: [],
            searchForItem:[]
        })
        await this.filterData()
        await this.getFilterList()
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    getFilterList = async () => {
        await this.props.GetFilterList()
        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })
        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode })
    }
    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
            })
        }
        await this.setState({ sortByVendor, VendorName })
        await this.filterData()
    }
    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })
        await this.filterData()
    }
    handleSelectPO = async (e) => {
        let sortByPo = []
        let POSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
                POSAPId.push(item)
            })
        }
        await this.setState({ sortByPo, POSAPId })
        await this.filterData()
    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.filterData()
    }
    getFilterList = async () => {
        await this.props.GetFilterList()
        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })
        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode })
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }
    render() {
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        console.log(this.state.employee, "abc")

        // stating pagination
        const { currentPage, posPerpage } = this.state;

        // Logic for displaying todos
        const indexOfLastTodo = currentPage * posPerpage;
        const indexOfFirstTodo = indexOfLastTodo - posPerpage;
        const currentTodos = this.state.tableData;

        var roles = authInstance.getRoles()
        var varId = this.state.varId
        console.log(this.state.varId, "this.state.varId")

        var permissions = AuthHandlerInstance.getPermissions()
        console.log(this.props.poDetails.loading, "||||||||||||")
        if (this.props.poDetails.loading) {
            return (
                <Loading />
            )

        }
        else {
            return (

                <div className="Container-fluid p-4 pageheight">
                    {/*----------Document comment-------------- */}
                    {
                        varId ? (<Manufacturing_Clearence action={this.state.Manufacturing_Clearence} toggleManufacturing_Clearence={(e) => this.toggleManufacturing_Clearence(e)} PoLineId={varId} />) : null
                    }
                    {/*----------Document Comment end  */}
                    <div className="row justify-content-between">
                        <div className="col-md-3 header">
                            <b>Manufacturing Clearence</b>
                        </div>
                        {roles[12] ?
                            <div className="col-md-4 pt-3">
                                <button disabled={(this.state.selected.length && currentTodos.find(item => item.isHold == 1 && this.state.selected.includes(item.PurchaseOrderLineId))) || this.state.selected.length == 0 ? true : false} onClick={() => this.updateStatus(1)} className="btn2 btn-sms1 rounded-pill float-right">Hold</button>
                                <button disabled={(this.state.selected.length && currentTodos.find(item => item.isHold == null && this.state.selected.includes(item.PurchaseOrderLineId))) || this.state.selected.length == 0 ? true : false} onClick={() => this.updateStatus(2)} className="btn2 btn-sms1 rounded-pill float-right">Release</button>
                                <button disabled={(this.state.selected.length && currentTodos.find(item => item.isHold == 1 && this.state.selected.includes(item.PurchaseOrderLineId))) || this.state.selected.length == 0 ? true : false} onClick={() => this.updateStatus(3)} className="btn2 btn-sms1 rounded-pill float-right">Give Clearence</button>
                            </div>
                            : null}
                        <div className="col-5 pt-3"
                        // style={{ paddingRight: 35 }}
                        >
                            <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                        </div>

                    </div>
                    {this.state.isShowFilter ?
                        <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal filter-data pr-2 pl-2">
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Project No." isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                            </div>
                            <div className="col">
                                <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                            </div>
                        </div>
                        : null}

                    <div className="row">
                        <div className="col-md-12 centre-alligned">
                            {this.state.loading ?
                                <Loading />
                                :
                                <Table className="table1 text-left ">
                                    <thead>
                                        <tr>
                                            {roles[12] ? <th className="align-middle col-md-1"> <input type="checkbox" onClick={this.handleChange} checked={this.state.select} /></th> : null}
                                            <th className="align-middle col-md-1">PO Number</th>
                                            <th className="align-middle col-md-1">PO Lineitem No.</th>
                                            <th className="align-middle col-md-3">Vendor</th>
                                            <th className="align-middle col-md-1">Stat. Del. Date</th>
                                            <th className="align-middle col-md-1">Net Value</th>
                                            <th className="align-middle col-md-1">Location</th>
                                            <th className="align-middle col-md-2">Status</th>
                                            <th className="align-middle col-md-1">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.props.poDetails.loading === false) ?
                                            currentTodos.map((item, Index) => (
                                                <tr>
                                                    {roles[12] ? <td className="col-md-1 align-middle headeralign"><input type="checkbox" checked={this.state.selected.includes(item.PurchaseOrderLineId) == true ? true : false} hidden={item.DeletionIndicator} onChange={(event) => this.handleSingleCheckboxChange(item.PurchaseOrderLineId)} value="" /></td> : null}
                                                    <td className="col-md-1 align-middle headeralign">{item.POSAPId}</td>
                                                    <td className="col-md-1 align-middle text-center">{item.POLineItemSAPCode}</td>
                                                    <td className="col-md-3 align-middle headeralign">{item.VendorName}</td>
                                                    <td className="col-md-1 align-middle text-center">{dateFormater(item.PODeliveryDate)}</td>
                                                    <td className="col-md-1 align-middle amount-text">{item.POLineItemAmount ? numberWithCommas(item.POLineItemAmount.toFixed(2)) : 0}</td>
                                                    <td className="col-md-1 align-middle headeralign">{item.Location}</td>
                                                    <td className="col-md-2 align-middle">{item.TrnStatusID < 7 || (item.TrnStatusID == 7 && item.ExpeditingStatusId == 0) ? item.TrnStatusName : item.TrnStatusID == 7 && item.ExpeditingStatusId == 1 ? item.TrnStatusName + " & " + item.ExpeditingStatusName : item.ExpeditingStatusName}</td>
                                                    <td className="col-md-1 align-middle headeralign text-center">
                                                        <div className="row justify-content-md-center">
                                                            <div className="col">
                                                                <FontAwesomeIcon icon={"sms"} color={"black"} title="View" size="lg" onClick={() => this.rowClick(Index)} />
                                                            </div>
                                                        </div>
                                                        {(item.ManufacturingClearence !== null && item.isHold !== null) || (item.ManufacturingClearence !== 0 && item.isHold !== 0) ?
                                                            item.ManufacturingClearence == 1 ?
                                                                <>
                                                                    <div className="row justify-content-md-center">
                                                                        <span className={"badge small-badge  " + this.state.docStatus[3]['badge']}>
                                                                            {this.state.docStatus[3]['title']}
                                                                        </span>
                                                                    </div>
                                                                    <div className="row mt-1 justify-content-md-center">
                                                                        <span className={"badge small-badge  " + this.state.docStatus[3]['badge']}>
                                                                            {`By ${item.ClearenceActedBy}`}
                                                                        </span>
                                                                    </div>
                                                                </>
                                                                : item.isHold > 0 ?
                                                                    <>
                                                                        <div className="row justify-content-md-center">
                                                                            <span className={"badge small-badge " + this.state.docStatus[item.isHold]['badge']}>
                                                                                {this.state.docStatus[item.isHold]['title']}
                                                                            </span>
                                                                        </div>
                                                                        <div className="row mt-1 justify-content-md-center">
                                                                            <span className={"badge small-badge " + this.state.docStatus[item.isHold]['badge']}>
                                                                                {`By ${item.ClearenceActedBy}`}
                                                                            </span>
                                                                        </div>
                                                                    </>
                                                                    : null
                                                            : null
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                            : null}
                                    </tbody>
                                </Table>
                            }
                        </div>
                    </div>
                    <div className="float-right">
                        <hr></hr>
                        <PaginationComponent filteredTodos={currentTodos} currentPage={currentPage} posPerpage={posPerpage} totalPos={this.state.totalPos} handleClick={this.handleClick} />
                        <hr></hr>
                    </div>
                </div>

            )
        }
    }
}



const mapStateToProps = (state) => ({ poDetails: state.poDetails, filterList: state.masterReducer.filterList, })
export default connect(mapStateToProps, { getPODetails, GetPOAndPOLineItemSummary, getSearchedPO, updatePOLineItemClearenceStatus, GetFilterList, getProjectAllocationByUserId })(ManufacturingClearence)
